<template>
    <div>
        <CList @FiltrarC="Lista" :pConfigList="ConfigList" :pFiltro="Filtro" :segurity="segurity">
            <template slot="header">
                <th :class="StyleTh+' text-center'">#</th>
                <th :class="StyleTh">Pregunta</th>
                <th :class="StyleTh">Tipo de Pregunta</th>
                <th :class="StyleTh">Tipo de Respuesta</th>
                <th :class="StyleTh+' text-center'">Acciones</th>
            </template>
            <template slot="body">
                <tr v-for="(item,index) in ListaArrayRows" :key="index">
                    <td class="text-center"><p :class="StyleTd">{{(index+1)}}</p></td>
                    <td><h6 :class="StylePr">{{item.Pregunta}}</h6></td>
                    <td><p :class="StyleTd">{{DevolverTipoPregunta(item.TipoPregunta)}}</p></td>
                    <td><p :class="StyleTd">{{item.TipoRespuesta}}</p></td>
                    <td>
                        <CBtnAccion :pShowBtnEdit="true" :pShowBtnDelete="true" :pIsModal="true" :pId="item.IdConfigEncuestaPregunta" :pEmitSeccion="ConfigList.EmitSeccion" :segurity="segurity">
                            <template slot="btnaccion">
                                <!-- Remover segurity del v-show en caso de agregar más botones -->
                                <CMoreButtonsL v-show="item.TipoPregunta=='3' && segurity.ViewSection">
                                    <template slot="bodyBtnsL">
                                        <template v-if="segurity.ViewSection">
                                            <li @click="IrARespuesta(item.IdConfigEncuestaPregunta)">
                                                <a class="dropdown-item">
                                                    <i class="far fa-list"></i> Ver Respuestas
                                                </a>
                                            </li>
                                        </template>
                                    </template>
                                </CMoreButtonsL>
                            </template>
                        </CBtnAccion>
                    </td>
                </tr>
                <CSinRegistros :pContIF="ListaArrayRows.length" :pColspan="5"></CSinRegistros>
            </template>
        </CList>
        <CModal :pConfigModal="ConfigModal" :poBtnSave="oBtnSave">
			<template slot="Form">
				<Form :poBtnSave="oBtnSave" :IdConfigEncuesta="IdConfigEncuesta"></Form>
			</template>
		</CModal>
    </div>
</template>

<script>
import Configs from '@/helpers/VarConfig.js';
const EmitEjecuta = 'seccionEncuestaPregunta';
import Form from '@/views/modulos/crm/encuesta/pregunta/Form.vue';
export default {
    name: 'ListaEncuestaPregunta',
    props: ['sFiltros','pOrigen','IdConfigEncuesta'],
    components: {
        Form
    },
    data() {
        return {
            ConfigList:{
                Title: 'Preguntas',
                IsModal: true,
                ShowLoader: true,
                EmitSeccion: EmitEjecuta,
                BtnReturnShow: true,
                TitleFirst: 'Encuesta',
            },
            Filtro:{
                Nombre: '',
                Pagina: 1,
                Entrada: 25,
                TotalItem: 0,
                Placeholder: 'Buscar..',
            },
            ConfigModal:{
                ModalTitle: "Formulario",
                ModalNameId: 'ModalForm',
                EmitSeccion: EmitEjecuta,
                ModalSize:'lg'
            },
            oBtnSave:{
                Toast: 0,
                IsModal: true,
                DisableBtn: false,
                EmitSeccion: EmitEjecuta,
            },
            segurity: {},
            // obj: {},
            ListaArrayRows: [],               
            StyleTh: Configs.stylesTable.StyleTh,
            StylePr: Configs.stylesTable.StylePr,
            StyleTd: Configs.stylesTable.StyleTd,
        }
    },
    methods: {
        async Lista(){
            this.ConfigList.ShowLoader=true;
            
            await this.$http.get('configEncuestaPreguntas/',{
                params:{
                    TxtBusqueda:this.Filtro.Nombre,
                    Pag:this.Filtro.Pagina,
                    Entrada:this.Filtro.Entrada,
                    IdConfigEncuesta:this.IdConfigEncuesta
                }
            }).then((res)=>{
                this.Filtro.Pagina      = res.data.data.current_page;
                this.Filtro.TotalItem   = res.data.data.total;
                this.segurity           = res.data.segurity;
                this.ListaArrayRows=res.data.data.data;
            }).finally(()=>{
                this.ConfigList.ShowLoader=false;
            })
        },
        Eliminar(Id){
            this.$swal(Configs.configEliminar).then((result) =>
            {
                if(result.value)
                {
                    this.$http.delete('configEncuestaPreguntas/'+Id
                    ).then((res) => {
                        this.$swal(Configs.configEliminarConfirm);
                        this.Lista();
                    }).catch(err => {
                        this.$toast.error(err.response.data.message);
                    });
                } 
            });
        },
        Regresar(){
            this.$router.push({name:"encuesta"});
        },
        IrARespuesta(Id){
            this.$router.push({name:'respuestas',params:{'IdConfigEncuestaPregunta':Id,'IdConfigEncuesta':this.IdConfigEncuesta}});
        },
        DevolverTipoPregunta(TipoPregunta){
            let Tipo=''
            switch (TipoPregunta) {
                case '1':
                    Tipo='Opción por Defecto'
                    break;
                case '2':
                    Tipo='Opción de Encuesta'
                    break;
                case '3':
                    Tipo='Anexada'
                    break;
                case '4':
                    Tipo='Valoración 1 - 10'
                    break;
                case '5':
                    Tipo='Si - No'
                    break;
                case '6':
                    Tipo='Pregunta Abierta'
                    break;
            }
            return Tipo;
        }
    },
    created() {
        if(this.pOrigen != undefined){
            sessionStorage.setItem('menuOrigen',JSON.stringify(this.pOrigen));
        }

        let Origen = JSON.parse(sessionStorage.getItem('menuOrigen'));
        if(Origen){
            this.ConfigList.TitleFirst = Origen;
        }
        else{
            this.ConfigList.ShowTitleFirst = false;
        }
        
        this.bus.$off('Delete_'+EmitEjecuta);
        this.bus.$off('List_'+EmitEjecuta);
        this.bus.$off('EmitReturn');
    },
    mounted() {
        this.Lista();
        this.bus.$on('Delete_'+EmitEjecuta,(Id)=>
        {
            this.Eliminar(Id);
        });

        this.bus.$on('List_'+EmitEjecuta,()=>
        {
            this.Lista();
        });

        this.bus.$on('EmitReturn',()=>
        {
            this.Regresar();
        });
    },
}
</script>

<style>

</style>